import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import MAR from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MAR />
  </React.StrictMode>
);

reportWebVitals();
